import React from 'react';
import 'react-toastify/dist/ReactToastify.css';
import './index.css';
import 'normalize.css';
import {App} from './components/App/App';
import './i18n';
import i18next from "i18next";
import {initReactI18next} from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import messages from './translations/iframe_messages.json';
import moment from "moment";
import axios from "axios";
import {createRoot} from "react-dom/client";

i18next
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        detection: {
            order: ["navigator"]
        },
        lng: "ru",
        debug: true,
        fallbackLng: "common",
        resources: messages,
    })
    .catch(err => console.debug("i18n error: " + err));

i18next.on("languageChanged", lng => {
    console.debug("Language changed to", "ru");
    moment.locale("ru");
    axios.defaults.headers.common["Accept-Language"] = "ru";
});

axios.defaults.paramsSerializer =  (params) => JSON.stringify(params);
const domNode = document.getElementById('root');
domNode && createRoot(domNode).render(<App/>)
